import { UseFormReturn } from 'react-hook-form'

import { CustomFormQuestion } from 'components/tools/CustomForm/types'

type Params = {
  formMethods: UseFormReturn<any>
  questions: CustomFormQuestion[]
}

export default function setCATComunicacaoDeAcidenteDeTrabalho(params: Params): CustomFormQuestion[] {
  const { formMethods, questions } = params

  const { watch } = formMethods

  const titleForQuestion = Object.fromEntries(questions.map((q) => [q.title, q.slug]))

  const tipoDeOcorrencia = watch(`form_answers.${titleForQuestion['Tipo de Ocorrência']}`)

  const acidenteDeTrajeto = watch(`form_answers.${titleForQuestion['Acidente de trajeto']}`)

  const filteredQuestions = questions.filter((question) => {
    // tipoDeOcorrencia
    if (
      question.title == 'Data do diagnóstico' ||
      question.title == 'Local da ocorrência' ||
      question.title == 'Horário do acidente' ||
      question.title == 'Houve afastamento' ||
      question.title == 'Descrição do caso' ||
      question.title == 'Profissional que fez o diagnóstico' ||
      question.title == 'CRM ou Registro Profissional'
    ) {
      if (tipoDeOcorrencia == 'Acidente Típico' || tipoDeOcorrencia == 'Doença Ocupacional') {
        return true
      } else {
        return false
      }
    }

    // acidenteDeTrajeto
    if (question.title == 'Meio de locomoção' || question.title == 'Percuso' || question.title == 'Houve B.O') {
      if (acidenteDeTrajeto == 'Sim') {
        return true
      } else {
        return false
      }
    }

    return true
  })

  return filteredQuestions
}
